import { styled } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const NavLinkW = styled(NavLink)`
  color: ${({ theme }) => theme.palette.info.main};
`;

export const InnerContainer = styled('div')`
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  background: ${({ theme }) => theme.palette.white.main};
  border-radius: 8px;
  margin-top: 40px;
  width: 100%;
  height: 100%;
  min-height: 250px;
  padding: 16px;

  @media (max-width: 1023px) {
    margin-top: 16px;
  }
`;

export const SeeAllLink = styled(NavLink)`
  display: block;
  text-align: right;
  align-items: flex-end;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.p080};
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    opacity: 0.7;
  }
`;

export const TaskListW = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
`;
